var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { Accordion } from "syf-component-library/ui/patterns";
import { Inline, Inset, Stack } from "syf-component-library/ui/spacing";
import { Body } from "syf-component-library/ui/typography";
import { AccordionBodyWrapper, AccordionHeaderWrapper, AccordionIcon, } from "./subcomponents";
var TipAccordion = function (_a) {
    var reasons = _a.reasons;
    var _b = useState({
        "accordion-1": false,
        "accordion-2": false,
    }), modal = _b[0], setModal = _b[1];
    var toggleModal = function (id) {
        var _a;
        var newState = __assign(__assign({}, modal), (_a = {}, _a[id] = !modal[id], _a));
        setModal(newState);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), reasons === null || reasons === void 0 ? void 0 : reasons.map(function (reasonData) {
                var reasonCode = reasonData.reasonCode;
                return (_jsxs("div", { children: [_jsx(Accordion, { id: reasonCode, header: _jsx(Inset, __assign({ top: "small" }, { children: _jsxs(AccordionHeaderWrapper, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: reasonData.description })), _jsx(Inline, {}), reasonCode && modal[reasonCode] ? (_jsx(AccordionIcon, { color: "#34657F", size: "lg", icon: faChevronUp })) : (_jsx(AccordionIcon, { color: "#34657F", size: "lg", icon: faChevronDown }))] }) })), body: _jsxs(AccordionBodyWrapper, { children: [_jsx(Body, { children: reasonData.explanation }), _jsx(Stack, { size: "large" }), _jsx(Body, { children: reasonData.resolution })] }), transitionDuration: 0.1, forceClose: false, forceRerenderBody: true, headerClickCallBack: function () {
                                toggleModal(reasonCode);
                            } }), _jsx(Stack, { size: "large" })] }, reasonCode));
            })] }));
};
export default TipAccordion;
